import { ListItem } from "@mui/material";
import { useLayoutEffect } from "react";
import { useIsStorybook } from "utils/customHooks/storyHooks";

// to get the storybook tests passing, we can't use button={true} at all in any story
export const ListItemButton = ({ children, ...props }) => {
  const isStorybook = useIsStorybook();

  return isStorybook ? (
    <ListItem {...props}>{children}</ListItem>
  ) : (
    <ListItem button={true} {...props}>
      {children}
    </ListItem>
  );
};
/** compensate for scrollbar disappearing, prevents DashboardPageContent re-render due to width changing (prevents layout shift) */
export function useCompensateForScrollbarVisibilityToPreventPageRerender(
  open: boolean
) {
  useLayoutEffect(() => {
    const dashboardPageContent = document.querySelector<HTMLElement>(
      `[data-component-name="Dashboard Page"]`
    );
    if (!dashboardPageContent) {
      return;
    }

    const scrollbarVisible = isScrollbarVisible(dashboardPageContent);

    if (open && scrollbarVisible) {
      dashboardPageContent.style.paddingRight = "16px";
    } else {
      dashboardPageContent.style.paddingRight = "";
    }
  }, [open]);
}

function isScrollbarVisible(element: HTMLElement): boolean {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}
